<template>
  <div
    ref="actionsPopup"
    class="actions-menu-container"
  >
    <button
      type="button"
      title="Additional actions"
      @click="showActions = true; startTimer()"
    >
      <img
        src="/images/icons/action-menu.svg"
        class="action-icon"
      >
    </button>
    <button
      title="View notes added by you or others"
      @click="listNotes"
    >
      <img
        v-if="noteExist"
        class="note-icon"
        src="/images/icons/view_notes.svg"
        title="View Notes"
      >
    </button>
    <div
      v-if="showActions"
      ref="actionsMenu"
      class="actions-menu-popup"
      :class="{'show-bookmark': showBookmark}"
    >
      <button
        type="button"
        title="Exclude this item"
        @click="excludeFilter"
      >
        <img
          src="/images/icons/exclude1.svg"
          class="action-icon"
        >
      </button>
      <note-buttons
        :inActionMenu="true"
        :noteId="noteId"
        :noteName="noteName"
        :noteLinked="message._id"
        :noteSiteId="message._source.site_id"
        :noteSiteName="message._source.site_name"
        :noteItem="noteItem"
        :hasNotes="hasNotes"
        :indexType="indexType"
        :siteLink="siteLink"
        :watchlistMessage="message"
        :showUserNotes="showUserNotes"
        @refresh="refresh"
        @listNotes="listNotes"
      />
      <AddItemWatchlist
        v-if="message"
        :message="message"
        :watchlistItemName="noteName"
        :watchlistItemId="watchlistItemId"
        :itemName="noteName"
        :siteName="siteName"
        :siteId="siteId"
        :docId="message._id || message.uuid"
        :siteType="message._type || indexType === 'forum' ? 'forum_posts' : 'chat_messages'"
        :noteItem="noteItem"
      />
      <bookmark-button
        v-if="showBookmark"
        :message="message"
        :bookmarked="message.bookmarked"
        @bookmarkRemoved="bookmarkRemoved"
      />
    </div>
    <UserNote
      v-if="showUserNotes"
      :usernotes="usernotes"
      :indexType="indexType"
      :noteSiteName="message._source.site_name"
      :siteLink="siteLink"
      @listEmpty="listEmpty"
      @closed="showUserNotes = false"
      @add="addNoRefUserNote"
    />
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import NoteButtons from './notes/NoteButtons'
import UserNote from './notes/UserNote'
import AddItemWatchlist from './watchlist/AddItemWatchlist'
import BookmarkButton from './message_search/BookmarkButton'

export default {
  name: 'ActionsMenu',
  components: {
    NoteButtons,
    AddItemWatchlist,
    UserNote,
    BookmarkButton
  },
  props: {
    message: {
      type: Object,
      default: () => {}
    },
    filterTerm: {
      type: [String, Number],
      default: ''
    },
    filterType: {
      type: String,
      default: ''
    },
    siteLink: {
      type: String,
      default: ''
    },
    noteId: {
      type: [ String, Number ],
      default: null
    },
    noteItem: {
      type: String,
      default: ''
    },
    hasNotes: {
      type: Boolean,
      default: null
    },
    indexType: {
      type: String,
      default: ''
    },
    noteName: {
      type: String,
      default: null
    },
    showBookmark: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showActions: false,
      noteExist: false,
      showUserNotes: false,
      usernotes: [],
      timer: null
    }
  },
  computed: {
    watchlistItemId() {
      return (this.message._source) ? this.message._source.site_id : this.message.site.site_id
    },
    siteName() {
      return (this.message._source) ? this.message._source.site_name : this.message.site.site_name
    },
    siteId() {
      return (this.message._source) ? this.message._source.site_id : this.message.site.site_id
    }
  },
  watch: {
    hasNotes() {
      this.noteExist = this.hasNotes
    }
  },
  mounted() {
    this.noteExist = this.hasNotes
    document.addEventListener('click', this.clickOutsideMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutsideMenu)
  },
  methods: {
    excludeFilter() {
      let filter = {
        'mode': '-',
        'type': this.filterType,
        'term': this.filterTerm,
      }
      this.$store.commit('addFilters', [filter])
      this.$store.commit('start', 0)
      this.showActions = false
    },
    refresh() {
      this.$emit('refresh')
    },
    listNotes() {
      const csrftoken = Cookies.get('csrftoken')
      this.showUserNotes = true
      let notes = {
        'choice_id': this.noteId,
        'name': this.noteName,
        'item': this.noteItem,
        'site_id': this.message._source.site_id,
        'site_name': this.message._source.site_name
      }
      axios.post('/en/message-search/notes/list/', notes, {'headers': {'X-CSRFToken': csrftoken}}).then(response => {
        this.usernotes = response.data.list_data
      })
    },
    listEmpty() {
      this.noteExist = false
      this.usernotes = []
      this.$emit('refresh')
    },
    addNoRefUserNote(value) {
      this.showInputFields = true
      this.showUserNotes = false
    },
    clickOutsideMenu(e) {
      if (!this.$refs.actionsPopup.contains(e.target) && this.showActions) {
        this.showActions = false
        this.removeTimer()
      }
    },
    bookmarkRemoved() {
      this.$emit('bookmarkRemoved')
    },
    startTimer() {
      this.$nextTick(() => {
        this.$refs.actionsMenu.addEventListener('mouseleave', this.hideMenu)
        this.$refs.actionsMenu.addEventListener('mouseenter', this.removeTimer)
      })
    },
    removeTimer() {
      clearTimeout(this.timer)
    },
    hideMenu() {
      this.timer = setTimeout(() => {
        this.showActions = false
      }, 2000)
    }
  }
}
</script>

<style scoped>
.actions-menu-container {
  position: relative;
  display: inline-block;
}
.actions-menu-popup {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: #f5f5f4;
  padding: 10px;
  border: 2px solid hsl(11, 3%, 27%);
  border-radius: 6px;
  min-width: 123px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.show-bookmark {
  min-width: 156px;
}
.action-icon {
  width: 30px;
  height: auto;
}
</style>
